import getFetchNonce from '@github-ui/fetch-nonce'
import {forwardRef} from 'react'

export type IncludeFragmentProps = JSX.IntrinsicElements['include-fragment']

function IncludeFragmentWithRef({children, ...props}: IncludeFragmentProps, ref: React.Ref<HTMLElement>) {
  return (
    // eslint-disable-next-line react/forbid-elements
    <include-fragment {...props} ref={ref} data-nonce={getFetchNonce()}>
      {children}
    </include-fragment>
  )
}

export const IncludeFragment = forwardRef(IncludeFragmentWithRef)

try{ IncludeFragmentWithRef.displayName ||= 'IncludeFragmentWithRef' } catch {}
try{ IncludeFragment.displayName ||= 'IncludeFragment' } catch {}